import { render, staticRenderFns } from "./CytologyTextPreview.vue?vue&type=template&id=0550e9ab&scoped=true&"
import script from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
export * from "./CytologyTextPreview.vue?vue&type=script&lang=js&"
import style0 from "./CytologyTextPreview.vue?vue&type=style&index=0&id=0550e9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0550e9ab",
  null
  
)

export default component.exports